import React from "react";

import Victory from '../images/retrostylegames2.webp'

function AllDone() {
    return <img src={Victory} alt="Nice" />
}

export default AllDone;